import { parseSelector } from './selectorParser';
import { createMatches } from './matches';
export function createQuerySelector(options, matches) {
  var _matches = matches || createMatches(options);

  function findSubtree(selector, depth, node) {
    if (!node) {
      return [];
    }

    var n = _matches(selector, node);

    var matched = n ? typeof n === 'object' ? [n] : [node] : [];

    if (depth === 0) {
      return matched;
    }

    var childMatched = options.children(node).filter(function (c) {
      return typeof c !== 'string';
    }).map(function (c) {
      return findSubtree(selector, depth - 1, c);
    }).reduce(function (acc, curr) {
      return acc.concat(curr);
    }, []);
    return matched.concat(childMatched);
  }

  function findSibling(selector, next, node) {
    if (!node || options.parent(node) === undefined) {
      return [];
    }

    var results = [];
    var siblings = options.children(options.parent(node));

    for (var i = siblings.indexOf(node) + 1; i < siblings.length; i++) {
      if (typeof siblings[i] === 'string') {
        continue;
      }

      var n = _matches(selector, siblings[i]);

      if (n) {
        if (typeof n === 'object') {
          results.push(n);
        } else {
          results.push(siblings[i]);
        }
      }

      if (next) {
        break;
      }
    }

    return results;
  }

  return function querySelector(selector, node) {
    if (!node) {
      return [];
    }

    var sel = typeof selector === 'object' ? selector : parseSelector(selector);
    var results = [node];
    var currentSelector = sel;
    var currentCombinator = 'subtree';
    var tail = undefined;

    var _loop_1 = function _loop_1() {
      tail = currentSelector.nextSelector;
      currentSelector.nextSelector = undefined;

      if (currentCombinator === 'subtree' || currentCombinator === 'child') {
        var depth_1 = currentCombinator === 'subtree' ? Infinity : 1;
        results = results.map(function (n) {
          return findSubtree(currentSelector, depth_1, n);
        }).reduce(function (acc, curr) {
          return acc.concat(curr);
        }, []);
      } else {
        var next_1 = currentCombinator === 'nextSibling';
        results = results.map(function (n) {
          return findSibling(currentSelector, next_1, n);
        }).reduce(function (acc, curr) {
          return acc.concat(curr);
        }, []);
      }

      if (tail) {
        currentSelector = tail[1];
        currentCombinator = tail[0];
      }
    };

    do {
      _loop_1();
    } while (tail !== undefined);

    return results;
  };
}